import React from "react";
import { Link } from "react-router-dom";

const ExpandableList = ({
  listData = [], // The main list data to display
  modalData = [], // Additional data to show when expanded
  showMoreOrLessKey, // The key used to toggle the "Show More" or "Show Less" state
  showMoreOrLess, // Object holding the state for "Show More" or "Show Less"
  toggleShowMoreOrLess, // Function to toggle the state
  sliceCount = 5, // Number of items to display when not expanded
  renderListItem, // Function to render each item in the list
  isPPEList = false, // Flag to identify if the list is PPE
}) => {
  const combinedData = showMoreOrLess[showMoreOrLessKey]
    ? [...listData, ...modalData] // Show all data when expanded
    : [
        ...listData.slice(0, sliceCount),
        ...modalData.slice(0, Math.max(0, sliceCount - listData.length)),
      ]; // Show a limited number when collapsed

  const totalItems = listData.length + modalData.length; // Total number of items    
  
  return (
    <div className="py-2">
      {!isPPEList ? (
        <ol>
          {combinedData.map((item) => (
            <li className="my-2" key={item.id} style={{ fontSize: "15px" }}>
              {renderListItem(item)}
            </li>
          ))}
        </ol>
      ) : (
        combinedData.map((data) => (
          <div key={data.id} className="d-flex align-items-center gap-3 my-3">
            {renderListItem(data)}
          </div>
        ))
      )}
      {totalItems > sliceCount && (
        <div className="mt-2">
          <Link
            to={"#"}
            onClick={() => toggleShowMoreOrLess(showMoreOrLessKey)}
            className="py-1 cursor-pointer"
          >
            {`Show ${showMoreOrLess[showMoreOrLessKey] ? "Less" : "More"}`}
          </Link>
        </div>
      )}
    </div>
  );
};

export default ExpandableList;
